import { contactInfo, myAccount } from '../../utils/footerInfo';
import paymentLogo from '../../assets/images/payment.png';
import SocialIcons from '../SocialIcons/SocialIcons';
import { useTranslation } from 'react-i18next';
import './Footer.scss';
const Footer = () => {
  const { t } = useTranslation();
  return (
    <section className="site-footer py-5">
      <div className="container">
        <div className="row site-footer__header">
          <div className="col-10 col-lg-2 mx-auto">
           <h1>LOGO</h1>
          </div>
          <div className="col-10 col-lg-5 mx-auto">
            <h5 className="site-footer__title">{t('Footer.1')}</h5>
            <p className="site-footer__text">
            {t('Footer.2')}
            </p>
          </div>
          <div className="col-10 col-lg-5 mx-auto">
            <form
              onSubmit={(e) => e.preventDefault()}
              className="site-footer__form"
            >
              <input
                type="email"
                className="site-footer__input"
                placeholder={t('Footer.3')}
              />
              <input
                type="submit"
                className="site-footer__btn"
                value={t('Footer.4')}
              />
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-10 col-lg-4 mx-auto site-footer__content">
            <h5 className="site-footer__content-title">{t('Footer.5')}</h5>
            {contactInfo.map((item) => {
              const { id, text } = item;
              return (
                <p className="site-footer__content-text" key={id}>
                  <span>{text}</span>
                </p>
              );
            })}
          </div>
          <div className="col-10 col-lg-4 mx-auto site-footer__content">
            <h5 className="site-footer__content-title">{t('Footer.6')}</h5>
            {myAccount.map((item) => {
              const { id, text } = item;
              return (
                <p className="site-footer__content-text" key={id}>
                  {text}
                </p>
              );
            })}
          </div>
          <div className="col-10 col-lg-4 mx-auto site-footer__content">
            <h5 className="site-footer__content-title">{t('Footer.6')}</h5>
            {myAccount.map((item) => {
              const { id, text } = item;
              return (
                <p className="site-footer__content-text" key={id}>
                  {text}
                </p>
              );
            })}
          </div>
        </div>
        <div className="row site-footer__footer">
          <div className="col-10 col-lg-4 mx-auto">
            <img src={paymentLogo} alt="payment" />
          </div>
          <div className="col-10 col-lg-4 mx-auto">
            <span className="site-footer__rights">
              <span className="site-footer__rights--author"><a href="https://linkedin.com/in/rustamovic/"
                    target="_blank"
                    rel="noopener noreferrer">Rustamovic</a></span>{' '}
              &copy; {new Date().getFullYear()}. {t('Footer.7')}
            </span>
          </div>
          <div className="col-10 col-lg-4 mx-auto">
            <SocialIcons />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
